<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">إضافة مجموعة</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/groups">المجموعات</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">إضافة مجموعة</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <mainLoader v-if="mainLoading" />
            <GroupsForm v-if="!mainLoading" 
              cardTitle="إضافة مجموعة" 
              :permissionsList="permissions"
              :modelsList="modelsList"
              :regionsList="regionsList"
            />
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import GroupsForm from './form.vue';

export default {
  name: 'GroupsCreate',
  components: {
    GroupsForm,
  }, 
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      permissions: [],
      modelsList: {},
      regionsList: [],
    };
  },
  methods: {
    getPermission(){
      this.$http.get(`/api/admin/groups/permissions`).then(({data}) => {
        this.permissions = data.permissions_list;
        this.modelsList = data.models_list;
        this.regionsList = data.regions;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }, 
  created(){
    this.getPermission();
  }
}
</script>
